<template>
    <div class="filter-comp">
        <div class="filter-block filter-title">
            <span>
                <img src="@/assets/img/icon/biz_filter_black.svg" alt="">
                篩選
            </span>
            <span v-show="filterState" class="clear-filter" @click="setFilterDefault">
                清除篩選
            </span>
        </div>
        <div class="filter-block">
            <table-search @changeWord="setFilterWord" :setDefault="isDefault"></table-search>
        </div>
        <div class="filter-block">
            <span v-if="isAllGroup" class="title">業務分群</span>
            <rent-select class="select-scroll" v-if="isAllGroup" refName="orgGroup" style="margin-bottom: 16px;" selectMsg="全部" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                <ul>
                    <li v-for="(item, index) in groupList" :key="index" :data-id="item.id" :data-name="item.groupName">
                        {{item.groupName}}
                    </li>
                </ul>
            </rent-select>
            <span class="title">業務</span>
            <rent-select class="select-scroll" refName="member" selectMsg="全部" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault || isGroupChange">
                <ul>
                    <li v-for="(item, index) in memberList" :key="index" :data-id="item.userCid" :data-name="item.name">
                        {{item.name}}
                    </li>
                </ul>
            </rent-select>
        </div>
        <div class="filter-block location">
            <div class="title">地點</div>
            <div class="group">
                <rent-select class="select-scroll" refName="county" selectMsg="所有縣市" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                    <ul>
                        <li :data-id="index" :data-name="county" v-for="(county, index) in countyResult" :key="index">
                            {{county}}
                        </li>
                    </ul>
                </rent-select>
                <rent-select class="select-scroll" refName="district" selectMsg="所有區域" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault || isCityChange">
                    <ul v-if="filter.countyId">
                        <li :data-id="index" :data-name="district.districtName" v-for="(district, index) in districtsResult" :key="index">
                            {{district.districtName}}
                        </li>
                    </ul>
                </rent-select>
            </div>
        </div>
        <div class="filter-block">
            <span class="title">出租類型</span>
            <rent-select refName="houseType" selectMsg="所有類型" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                <ul>
                    <li data-id="1">
                        整層住家
                    </li>
                    <li data-id="2">
                        套房
                    </li>
                    <li data-id="3">
                        雅房
                    </li>
                    <!-- <li data-id="3">
                        其他
                    </li> -->
                </ul>
            </rent-select>
        </div>
    </div>
</template>
<script>
import VueSlider from 'vue-slider-component'
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import DatePicker from 'vue2-datepicker';
import TableSearch from '@/components/widge/TableSearch.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            filter: {
                word: '',
                group: '',
                member: '',
                county: '',
                countyId: '',
                district: '',
                houseType: '',
            },
            filterState: 0,
            filterIsFixed: false,
            isDefault: false,
            isCityChange: false,
            isGroupChange: false,
            componentKey: 0
        }
    },
    mounted () {
        if(!this.isAllGroup){
            this.$store.dispatch('getBizMemberByGroupList', this.groupId)
        }
    },
    watch: {
        filter: {
            handler: function (val) {
                this.$store.dispatch('setBizBatchNotifyFilterQuery', val)
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        getSelectId: function (value) {
            this.filterState = 1
            this.isDefault = false
            if( value.ref == 'orgGroup' ){
                this.filter.group = value.name
                this.$store.dispatch('getBizMemberByGroupList',(value.id))
                this.isGroupChange = true
                this.filter.member = ''
            }else if( value.ref == 'member' ){
                this.filter.member = value.name
                this.isGroupChange = false
            }else if( value.ref == 'landlord' ){
                this.filter.landlord = value.name
            }else if( value.ref == 'houseType' ){
                this.filter.houseType = value.id
            }else if( value.ref == 'county' ){
                this.filter.county = value.name
                this.filter.countyId = value.id
                this.isCityChange = true
                this.filter.district = ''

                this.$store.dispatch('getDistrict',(parseInt(value.id)+1))
            }else if( value.ref == 'district' ){
                this.isCityChange = false
                this.filter.district = value.name
            }
        },
        setFilterWord: function (value) {
            this.filter.word = value
        },
        setFilterDefault: function () {
            let defaultFilter = {
                word: '',
                group: '',
                member: '',
                county: '',
                countyId: '',
                district: '',
                houseType: '',
            }
            this.filter = defaultFilter
            this.isDefault = true
            setTimeout(()=>{
                this.filterState = 0
                this.isDefault = false
            },100)
        },
        numValue: function (val) {
            if( val == '100000' ){
                return '$'+this.toCurrency(val)+'+'
            }else{
                return '$'+this.toCurrency(val)
            }
        },
    },
    computed: {
        ...mapGetters({
            countyResult: 'COUNTY_RESULT',
            districtsResult: 'DISTRICTS_RESULT',
            groupId: 'GET_BIZ_GROUP_ID',
            isAllGroup: 'GET_BIZ_IS_ALL_GROUP',
            groupList: 'GET_ORG_GROUP_LIST',
            memberList: 'GET_ORG_MEMBER_BY_GROUP_LIST',
            landlordList: 'GET_LANDLORD_LIST',
        })
    },
    components: {
        VueSlider,
        DatePicker,
        RentSelect,
        TableSearch
    }
}
</script>
<style lang="scss" scoped>
    .filter-comp{
        position: relative;
        width: 270px;
        background: #fff;
        border-radius: 8px;
        border: solid 1px #f0f0f0;
        padding-bottom: 20px;
        .title{
            display: block;
            font-size: 16px;
            margin-bottom: 16px;
        }
        .filter-block{
            padding: 20px;
            border-bottom:2px solid #f6f6f6 ;
            .biz-rent-select{
                padding: 13px 16px;
                height: 18px;
            }
            &.filter-title{
                span:nth-child(1){
                    display: flex;
                    align-items: center;
                    color: #676362;
                    img{
                        margin-right: 12px;
                    }
                }
                .clear-filter{
                    position: absolute;
                    cursor: pointer;
                    font-size: 12px;
                    color: #ff9275;
                    top: 24px;
                    right: 17px;
                }
            }
            > .table-search{
                input{
                    width: 100%;
                }
            }
            &.location{
                .group{
                    display: flex;
                    .biz-rent-select:nth-child(1){
                        margin-right: 10px;
                    }
                    .biz-rent-select{
                        width: 75px;
                        height: 18px;
                    }
                }
            }
        }
        
        
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/leaseMgt/batchNotify/batchNotifyFilter.vue